import React from "react";
import {
  Col,
  Grid,
  Layout,
  Radio,
  Row,
  Select,
  Switch,
  Tooltip,
  Typography,
  message,
} from "antd";
import {
  StyledButtonRow,
  StyledText,
  StyledModelSwitchContainer,
} from "./styles";
import { VideoCameraFilled } from "@ant-design/icons";
import { StyledPrimaryBackButton, StyledPrimaryButton } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "../../../../Components/Avatar";
import { useEffect, useState } from "react";
import { nullConfig } from "../../../../Redux/Slice/CasterSlice";

const { Option } = Select;
const { Content } = Layout;
const { Title } = Typography;
const { useBreakpoint } = Grid;

export const NewsSidebar = ({
  generateMedia,
  mediaType,
  setMediaType,
  setUnsavedChanges,
  unsavedChanges,
  editedText,
  handleBack,
  videoModel,
  setVideoModel,
  hideBackButton = false,
}) => {
  const vidconfig = useSelector((state: any) => state.caster.selectedConfig);
  const audioconfig = useSelector((state: any) => state.caster.selectedConfig);
  const dispatch = useDispatch();
  const screens = useBreakpoint();

  const { loading: audioLoading } = useSelector(
    (state: any) => state.data.audioData
  );
  const { loading: videoLoading } = useSelector(
    (state: any) => state.data.videoData
  );
  const { loading: captionedNewsReelLoading } = useSelector(
    (state: any) => state.data.captionedNewsReelData
  );

  const handleBackWithWarning = () => {
    const confirmLeave = window.confirm(
      "You have unsaved changes. Are you sure you want to leave?"
    );
    if (confirmLeave) {
      setUnsavedChanges(false);
      // dispatch(getDataNull());
      dispatch(nullConfig());
      handleBack();
    }
  };

  // Force video selection when slideshow model is selected
  useEffect(() => {
    if (videoModel === "slideshow") {
      setMediaType("video");
      setUnsavedChanges(true);
    }
  }, [videoModel, mediaType, setMediaType, setUnsavedChanges]);

  const handleBrowserBackButton = (event) => {
    if (unsavedChanges) {
      event.returnValue =
        "You have unsaved changes. Are you sure you want to leave?";
    }
  };

  useEffect(() => {
    window.onbeforeunload = handleBrowserBackButton;

    return () => {
      window.onbeforeunload = null;
    };
  }, [unsavedChanges]);

  const [tooltipVisible, setTooltipVisible] = useState(false);

  useEffect(() => {
    const shouldShowTooltip =
      (mediaType === "video" && !vidconfig?.image) ||
      (mediaType === "audio" && !audioconfig?.voice);

    setTooltipVisible(shouldShowTooltip);
  }, [mediaType, vidconfig, audioconfig]);

  const hasNoAudioMinutes = false; // Always allow generation
  const hasNoVideoMinutes = false; // Always allow generation

  const isGenerateDisabled =
    mediaType.length === 0 ||
    (mediaType === "video" && videoModel === "avatar" && !vidconfig?.image) ||
    !editedText ||
    (mediaType === "video" && videoLoading) ||
    (mediaType === "video" &&
      videoModel === "slideshow" &&
      captionedNewsReelLoading);

  const handleGenerateClick = () => {
    if (hasNoAudioMinutes) {
      message.error("You do not have enough audio minutes");
      return;
    }
    if (hasNoVideoMinutes) {
      message.error("You do not have enough video minutes");
      return;
    }
    generateMedia();

    if (mediaType === "audio") {
      message.success("Audio generation request sent!", 3);
    } else if (mediaType === "video") {
      if (videoModel === "slideshow") {
        message.success("Captioned News Reel generation request sent!", 3);
      } else {
        message.success("Avatar video generation request sent!", 3);
      }
    }
  };

  return (
    <Content
      style={{
        height: "100%",
        width: "100%",
        background: "white",
        borderRadius: "15px",
      }}
    >
      {!screens.xs && (
        <Row
          align="middle"
          style={{
            borderBottom: "0.5px solid lightgrey",
            height: screens.xxl ? "60px" : "40px",
          }}
        >
          <Title
            style={{
              fontFamily: "Inter",
              marginLeft: "20px",
              fontSize: "18px",
            }}
          >
            <VideoCameraFilled
              style={{ fontSize: "16px", marginRight: "3px", color: "#005461" }}
            />{" "}
            Media
          </Title>
        </Row>
      )}

      {/* Model Selection Switch */}
      <StyledModelSwitchContainer>
        <div>
          <StyledText style={{ fontSize: "14px", margin: 0 }}>
            Video Model
          </StyledText>
          {videoModel === "slideshow" ? (
            <div style={{ fontSize: "12px", color: "#666", marginTop: "2px" }}>
              Captioned News Reel
            </div>
          ) : (
            <div style={{ fontSize: "12px", color: "#666", marginTop: "2px" }}>
              Video with AI avatars
            </div>
          )}
        </div>
        <Switch
          checked={videoModel === "slideshow"}
          onChange={(checked) => {
            setVideoModel(checked ? "slideshow" : "avatar");
            setUnsavedChanges(true);
          }}
          checkedChildren="News Reel"
          unCheckedChildren="Avatar"
        />
      </StyledModelSwitchContainer>
      <Col span={22} offset={1} style={{ marginTop: "30px" }}>
        {/* <CustomTooltip
          title={
            mediaType === "video" && !vidconfig?.image
              ? "Please select an Avatar!"
              : mediaType === "audio" && !audioconfig?.voice
              ? "Please select a voice!"
              : ""
          }
          placement="topLeft"
          visible={tooltipVisible}
        > */}
        <Content
          style={{
            opacity: videoModel === "slideshow" ? 0.5 : 1,
            pointerEvents: videoModel === "slideshow" ? "none" : "auto",
          }}
        >
          <Avatar />
        </Content>
        {/* </CustomTooltip> */}
      </Col>
      <Content
        style={{
          backgroundColor: "white",
        }}
      >
        {/* <Col span={22} offset={1}> */}
        {/* <Row> */}
        {/* <Col span={12}>
              <StyledText
                style={{
                  fontSize: "16px",
                }}
              >
                <text style={{ color: "red" }}>*</text> Select Type
              </StyledText>
            </Col> */}
        {/* <Col span={12}>
              {mediaType === "video" && 
              <StyledText
                style={{
                  fontSize: "16px",
                }}
              >
                <text style={{ color: "red" }}>*</text> Video Model
              </StyledText>}
            </Col> */}
        {/* </Row> */}
        {/* <Row>
            <Col span={12}>
              <Radio.Group
                defaultValue="pdf"
                style={{
                  width: "90%",
                  height: screens.xxl ? "40px" : "20px",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                <Radio
                  style={{
                    fontWeight: "600",
                    fontSize: "16px",
                    fontFamily: "Lato",
                    opacity: videoModel === "slideshow" ? 0.5 : 1,
                  }}
                  value="audio"
                  disabled={videoModel === "slideshow"}
                  onClick={() => handleMediaTypeChange("audio")}
                >
                  Audio
                </Radio>
                <Radio
                  style={{
                    fontWeight: "600",
                    fontSize: "16px",
                    fontFamily: "Lato",
                  }}
                  value="video"
                  onClick={() => handleMediaTypeChange("video")}
                >
                  Video
                </Radio>
              </Radio.Group>
            </Col>
          </Row> */}
        {/* </Col> */}

        {hideBackButton ? (
          <Row justify={"end"} style={{ marginTop: "20px" }}>
            <StyledPrimaryButton
              style={{ width: "100%" }}
              type="primary"
              disabled={isGenerateDisabled}
              onClick={handleGenerateClick}
            >
              Generate
            </StyledPrimaryButton>
          </Row>
        ) : (
          <StyledButtonRow
            justify="end"
            align={"middle"}
            style={{
              borderTop: "0.5px solid lightgrey",
              height: "80px",
            }}
          >
            <StyledPrimaryBackButton
              style={{
                marginRight: "2%",
              }}
              type="primary"
              disabled={!editedText}
              onClick={handleBackWithWarning}
            >
              Go back
            </StyledPrimaryBackButton>
            <StyledPrimaryButton
              style={{
                marginRight: "2%",
              }}
              type="primary"
              disabled={isGenerateDisabled}
              onClick={handleGenerateClick}
            >
              Generate
            </StyledPrimaryButton>
          </StyledButtonRow>
        )}
      </Content>
    </Content>
  );
};
